/**
 * E1: el cliente del presupuesto se puede cambiar si no hay factura.
 * Run: npx tsx --test src/lib/presupuestoClienteEditable.test.ts
 */
const LOCKED_ESTADOS = new Set(["finalizado", "utilizado", "facturado"]);

export function presupuestoClienteEditable(p: {
  clienteEditable?: boolean;
  cliente_editable?: boolean;
  estado?: string | null;
} | null | undefined): boolean {
  if (!p) return false;
  if (p.clienteEditable === false || p.cliente_editable === false) return false;
  if (p.clienteEditable === true || p.cliente_editable === true) return true;
  const estado = (p.estado || "").trim().toLowerCase();
  return !LOCKED_ESTADOS.has(estado);
}
